module.exports = __webpack_public_path__ + "img/edge_patrimoine_cave.c8f9c68a.svg";